/** The foundation seeds this row even while new enrollment is disabled. */
export const VOLUME_BONUS_FOUNDATION_FLAG = 'lo_volume_bonus_enrollment_v1';
